import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'telewell-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Telewell',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 18773846337,
  email: 'support@telewell.care',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/telewell/index.js